export default class UserManager {
  constructor() {
    this.userData = {};
    this.token = '';
  }

  getUserData() {
    return this.userData;
  }

  getUserAccountId() {
    return this.userData.app_metadata.account.id;
  }

  setUserData(data) {
    this.userData = data;
  }

  setToken(token) {
    this.token = token;
  }

  getToken() {
    return this.token;
  }

  clearUserData() {
    this.userData = {};
  }
}
